import { SelectInterface } from '../../interfaces/Select';
import { FormSelectMulti } from '../../../../component/input/InputStyle';
import FormLabel from '../../../../component/input/FormLabel.component';
import MenuItem from '@material-ui/core/MenuItem';
import { ChangeEvent, useState } from 'react';
import { ListItemText, Checkbox, ListItemIcon } from '@material-ui/core';

export default function Form({ title, handleSubmitForm, initialValues, disabled, listItem, required, xs, sm, md, lg }: SelectInterface<string[]>) {
    

    const [ selectAll, setSelectAll] = useState(false)
    const [ open, setOpen] = useState(false)

    const handleChange = (event: ChangeEvent<{value: string[] }>) => {
        const partialList = [...event.target.value]
        
        if (partialList.includes('TODAS')){
            if(selectAll){
                handleSubmitForm([])
            } else {
                handleSubmitForm([...listItem])
            }
        } else {
            handleSubmitForm([...partialList.filter(item => item !== 'TODAS')])
        }
    }

    return (
        <FormLabel title={title} xs={xs || 12} sm={sm || 6} md={md} lg={lg} required={required}>
            <FormSelectMulti
                open={open}
                onOpen={() => setOpen(true)}
                onClose={() => setOpen(false)}
                displayEmpty={true}
                disabled={disabled}
                value={initialValues}
                onChange={handleChange}
                renderValue={(selected:any) => {
                    if (selected.length === 0) {
                      return <span style={{opacity: '0.5'}}>Selecione...</span>;
                    }
        
                    return selected.join(', ');
                  }}
                // renderValue={(selected:any) => selected.join(', ')}
            >
                <MenuItem disabled value="">
                    <span>Selecione...</span>
                </MenuItem>
                <MenuItem
                    value="TODAS"
                    onClick={() => {
                        setSelectAll(!selectAll)
                        if (!selectAll){
                            setOpen(false)
                        }
                    }}
                >
                    <ListItemIcon>
                        <Checkbox checked={initialValues.filter(item => item !== 'TODAS').length === listItem.length} />
                    </ListItemIcon>
                    <ListItemText  primary="Selecionar Todos" />
                </MenuItem>
                {listItem.map((item, index: number) => {
                    return (
                        <MenuItem value={String(item || index)} key={index}>
                            <Checkbox checked={initialValues.indexOf(item) > -1} />
                            <ListItemText primary={item} />
                        </MenuItem>
                    )
                })}
            </FormSelectMulti>
        </FormLabel>
    )
}
